(function () {
  'use strict';

  var buttonStates = new WeakMap();

  function isEnabled() {
    return !!(document.body && document.body.dataset.addToCartAnimation === 'true');
  }

  function visibleCartIcon() {
    var targets = document.querySelectorAll('.nav-actions__btn--cart .nav-action-control__icon, .nav-actions__btn--cart');
    for (var index = 0; index < targets.length; index += 1) {
      var target = targets[index];
      var rect = target.getBoundingClientRect();
      var style = window.getComputedStyle(target);
      if (rect.width > 0 && rect.height > 0 && style.display !== 'none' && style.visibility !== 'hidden') return target;
    }
    return null;
  }

  function preload(imageUrl) {
    if (!imageUrl) return;
    var image = new Image();
    image.src = imageUrl;
  }

  function setImage(button, imageUrl) {
    if (!(button instanceof Element)) return;
    if (imageUrl) button.dataset.atcAnimationImage = imageUrl;
    else button.removeAttribute('data-atc-animation-image');
  }

  function imageForVariant(variant, fallback) {
    if (!variant) return fallback || '';
    var image = variant.featured_image || variant.featuredImage;
    return image && (image.src || image.url) || fallback || '';
  }

  function scheduleButtonReset(button, sequence) {
    var state = buttonStates.get(button);
    if (!state || state.sequence !== sequence) return;
    // The longest checkmark transition is 985ms; Helio keeps the completed
    // state for another 800ms before restoring the normal button content.
    state.timer = window.setTimeout(function () {
      var latest = buttonStates.get(button);
      if (!latest || latest.sequence !== sequence) return;
      button.removeAttribute('data-atc-animation-active');
      buttonStates.delete(button);
    }, 1785);
  }

  function animateButton(button) {
    if (!(button instanceof HTMLElement)) return;
    var previous = buttonStates.get(button);
    if (previous && previous.timer) window.clearTimeout(previous.timer);
    var sequence = previous ? previous.sequence + 1 : 1;
    buttonStates.set(button, { sequence: sequence, timer: 0 });
    if (button.dataset.atcAnimationActive === 'true') {
      button.removeAttribute('data-atc-animation-active');
      void button.offsetWidth;
    }
    button.dataset.atcAnimationActive = 'true';
    scheduleButtonReset(button, sequence);
  }

  function createFlyElement(source, destination, imageUrl, mode, quantity) {
    if (!(source instanceof Element) || !(destination instanceof Element) || !imageUrl) return;
    var fly = document.createElement('axiom-fly-to-cart');
    fly.classList.add('atc-fly--' + mode);
    fly.setAttribute('aria-hidden', 'true');
    fly.style.backgroundImage = 'url("' + String(imageUrl).replace(/"/g, '\\"') + '")';
    fly.style.setProperty('--atc-fly-start-opacity', mode === 'sticky' ? '1' : '0');
    if (quantity > 1) {
      var count = document.createElement('span');
      count.className = 'atc-fly__quantity';
      count.textContent = String(quantity);
      fly.appendChild(count);
    }
    fly.source = source;
    fly.destination = destination;
    fly.useSourceSize = mode === 'sticky';
    document.body.appendChild(fly);
  }

  function play(options) {
    if (!isEnabled()) return false;
    options = options || {};
    var button = options.button;
    if (!(button instanceof HTMLElement) || button.disabled) return false;
    var mode = ['main', 'quick', 'sticky', 'upsell'].indexOf(options.mode) > -1 ? options.mode : 'main';
    var imageUrl = options.imageUrl || button.dataset.atcAnimationImage || '';
    animateButton(button);
    var destination = options.destination || visibleCartIcon();
    if (destination && Array.isArray(options.items)) {
      options.items.forEach(function (item) {
        if (!item) return;
        createFlyElement(item.source || button, destination, item.imageUrl, mode, Number(item.quantity) || 1);
      });
    } else if (destination && imageUrl) {
      createFlyElement(options.source || button, destination, imageUrl, mode);
    }
    return true;
  }

  class AxiomFlyToCart extends HTMLElement {
    connectedCallback() {
      var element = this;
      var source = element.source;
      var destination = element.destination;
      if (!(source instanceof Element) || !(destination instanceof Element)) {
        element.remove();
        return;
      }
      var sourceRect = source.getBoundingClientRect();
      var destinationRect = destination.getBoundingClientRect();
      if (element.useSourceSize) {
        element.style.setProperty('--atc-fly-width', sourceRect.width + 'px');
        element.style.setProperty('--atc-fly-height', sourceRect.height + 'px');
      }
      var startX = sourceRect.left + sourceRect.width / 2;
      var startY = sourceRect.top + sourceRect.height / 2;
      var endX = destinationRect.left + destinationRect.width / 2;
      var endY = destinationRect.top + destinationRect.height / 2;
      element.style.setProperty('--atc-fly-start-x', startX + 'px');
      element.style.setProperty('--atc-fly-start-y', startY + 'px');
      element.style.setProperty('--atc-fly-travel-x', endX - startX + 'px');
      element.style.setProperty('--atc-fly-travel-y', endY - startY + 'px');
      window.requestAnimationFrame(function () {
        var animations = typeof element.getAnimations === 'function' ? element.getAnimations() : [];
        if (!animations.length) {
          window.setTimeout(function () { element.remove(); }, element.classList.contains('atc-fly--sticky') ? 800 : 600);
          return;
        }
        Promise.allSettled(animations.map(function (animation) { return animation.finished; })).then(function () {
          element.remove();
        });
      });
    }
  }

  if (!window.customElements.get('axiom-fly-to-cart')) {
    window.customElements.define('axiom-fly-to-cart', AxiomFlyToCart);
  }

  document.addEventListener('pointerover', function (event) {
    var button = event.target.closest && event.target.closest('[data-atc-animation-button]');
    if (button && event.relatedTarget && button.contains(event.relatedTarget)) return;
    if (button && isEnabled()) preload(button.dataset.atcAnimationImage);
  });
  document.addEventListener('focusin', function (event) {
    var button = event.target.closest && event.target.closest('[data-atc-animation-button]');
    if (button && isEnabled()) preload(button.dataset.atcAnimationImage);
  });

  window.AxiomAddToCartAnimation = {
    isEnabled: isEnabled,
    imageForVariant: imageForVariant,
    play: play,
    preload: preload,
    setImage: setImage
  };
})();
